<template>
    <div class="p-userform">
    	<div v-if="edituser && edituser.fields">
			<v-userform :rolename="edituser.role" :uid="edituser.id" :isnew="!edituser.id" :formfields="edituser.fields"></v-userform>
		</div>
    </div>
</template>

<script>
import VUserform 			from '@/components/form/v-userform';

export default {
	name: 'p-userform',
	components: {
		VUserform
	},
	computed: {
		edituser(){
			return this.$store.getters.edituser;
		}
	},
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/p-userform.vue